/** Helpers shared by the assistant API and UI (backlog #8). */

/** Citation numbers ([1], [2][3], [1, 4]) referenced in an answer, restricted to 1..max, in order of first use. */
export function extractCitations(answer: string, max: number): number[] {
  const out: number[] = [];
  for (const m of answer.matchAll(/\[(\d{1,2}(?:\s*,\s*\d{1,2})*)\]/g)) {
    for (const part of m[1].split(',')) {
      const n = Number(part.trim());
      if (n >= 1 && n <= max && !out.includes(n)) out.push(n);
    }
  }
  return out;
}

export type AnswerSegment = { kind: 'text'; text: string } | { kind: 'cite'; n: number };

/** Splits an answer into text and citation segments so the UI can render [n] as links. Unknown numbers stay text. */
export function answerSegments(answer: string, max: number): AnswerSegment[] {
  const out: AnswerSegment[] = [];
  let last = 0;
  for (const m of answer.matchAll(/\[(\d{1,2}(?:\s*,\s*\d{1,2})*)\]/g)) {
    const nums = m[1].split(',').map(x => Number(x.trim()));
    if (!nums.every(n => n >= 1 && n <= max)) continue;
    if (m.index! > last) out.push({ kind: 'text', text: answer.slice(last, m.index) });
    for (const n of nums) out.push({ kind: 'cite', n });
    last = m.index! + m[0].length;
  }
  if (last < answer.length) out.push({ kind: 'text', text: answer.slice(last) });
  return out;
}

/** "/ask what is…" → "what is…"; anything else → null. */
export function parseAskCommand(text: string): string | null {
  const m = /^\/ask(?:\s+([\s\S]*))?$/i.exec(text.trim());
  if (!m) return null;
  return (m[1] ?? '').trim();
}
